import { Button, Container, Grid } from "@mui/material";
import { emptyList } from "asset/animations";
import { HeaderComp } from "components";
import { CartCard } from "components/cart";
import { useIsMounted } from "hooks";
import { useCartData, useProducts } from "hooks/useDataFetch";
import React, { useEffect } from "react";
import { useState } from "react";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const [cartData, setCartData] = useState([]);

  const { data } = useCartData();

  const products = useProducts();

  let navigate = useNavigate();

  let isMounted = useIsMounted();
  // console.log(data);
  const sumAmount = cartData?.reduce((accumulator, currentValue) => {
    return (
      accumulator +
      ((currentValue.price * ((currentValue?.discount || 0) + 100)) / 100) *
        currentValue.cartQuantity
    );
  }, 0);

  const totalDiscount = cartData?.reduce((accumulator, currentValue) => {
    return (
      accumulator +
      ((currentValue?.price * currentValue?.discount || 0) / 100) *
        currentValue.cartQuantity
    );
  }, 0);

  // console.log(cartData);

  // console.log(sumAmount);

  // console.log(totalDiscount);

  useEffect(() => {
    if (isMounted.current) {
      let cartArray = [];

      products?.data?.filter((product) => {
        let savedProduct = data?.find((item) => {
          return product.id === item.id;
        });
        if (savedProduct) {
          let newData = {
            ...product,
            cartQuantity: savedProduct?.quantity,
          };
          cartArray.push(newData);
        }
        return savedProduct;
      });
      setCartData(cartArray);
    }
  }, [isMounted, products?.data, data]);

  // console.log(cartData);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleBuy = () => {
    const arrayData = cartData?.map((item) => {
      return {
        id: item.id,
        quantity: item.cartQuantity,
      };
    });
    // console.log(arrayData);

    const orderData = {
      products: arrayData,
      deliveryDate: null,
      deliveryTime: null,
    };

    navigate("/cart/checkout", { state: { orderData } });
  };

  return (
    <main className="cart-main">
      <HeaderComp title="CART" />

      <section className="cart-main-section">
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={8}>
              <div className="cart-section-content">
                <div className="cart-total-item w-100">
                  <h3 className="cart-total-item-h3">
                    My Cart{" "}
                    {data && cartData?.length && (
                      <span>({data && cartData?.length})</span>
                    )}
                  </h3>
                </div>
                <div className="cart-item-left-section flex-column gap-2">
                  {cartData && cartData.length > 0 ? (
                    cartData.map((item) => {
                      return <CartCard key={item?.id} data={item} />;
                    })
                  ) : (
                    <div
                      className="flex-row align-items-center justify-content-center "
                      style={{ minHeight: "50vh" }}
                    >
                      <div className="flex-col align-items-center justify-content-center">
                        <Lottie
                          options={notFoundLottie}
                          height={300}
                          width={300}
                        />
                        <h3 className="text-center">Your cart is empty.</h3>
                      </div>
                    </div>
                  )}
                  <div className="place-order-section w-100 flex-row align-items-center ">
                    <Button onClick={handleBuy}>Go to Checkout</Button>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              {cartData?.length > 0 && (
                <div className="cart-item-right-section">
                  <div className="cart-total-item-price-title">
                    <h3>Price details</h3>
                  </div>
                  <div className="cart-right-price flex-column gap-1">
                    <div className="total-price flex-row align-items-center justify-content-between ">
                      <span>Price ( {cartData?.length} items )</span>
                      <span className="total-price-span">
                        SAR {sumAmount?.toFixed(2) || 0}
                      </span>
                    </div>
                    <div className="total-discount flex-row align-items-center justify-content-between ">
                      <span>Discount </span>
                      <span className="total-discount-span">
                        {" "}
                        - SAR {totalDiscount?.toFixed(2) || 0}
                      </span>
                    </div>
                    <div className="total-delivery-charge flex-row align-items-center justify-content-between ">
                      <span>Delivery Charges</span>
                      <span className="total-delivery-charge-span"> Free</span>
                    </div>
                  </div>
                  <div className="cart-save-amount flex-row align-items-center justify-content-between">
                    <span>Total Amount</span>
                    <span>
                      SAR {(sumAmount - totalDiscount).toFixed(2) || 0}
                    </span>
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </Container>
      </section>
    </main>
  );
};

export default Cart;
